<template>
  <div class="order">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav>
      <!-- <div class="source-list noSelect" slot="user-nav-let-center">
        <div class="source-item" v-for="(item, index) in list" :key="index"
             :class="{'active': item.source_id === form.source_id}" @click="onSource(item)">
          <span class="iconfont" :class="item.icon"></span>
          <div class="source-text">{{item.name}}</div>
        </div>
      </div> -->
    </user-nav>

    <div class="user-center">
      <!--      <div class="step-main noSelect">-->
      <!--        <div class="step-item" :class="{'active': stepCurrent === 0}" @click="onSelectStep(0)">录入收件信息</div>-->
      <!--        <div class="step-item" :class="{'active': stepCurrent === 1}" @click="onSelectStep(1)">选择商品</div>-->
      <!--      </div>-->

      <div class="source-list noSelect" slot="user-nav-let-center">
        <div class="source-item" v-for="(item, index) in list" :key="index" :class="{ active: item.source_id === form.source_id }" @click="onSource(item)">
          <span class="iconfont" :class="item.icon"></span>
          <div class="source-text">{{ item.name }}</div>
        </div>
      </div>
      <!--录入收件信息-->
      <el-tabs class="border-card-main" type="border-card" @tab-click="handleClick" v-model="activeName">
        <el-tab-pane v-for="item in tabs" :key="item.id" :label="item.name" :name="item.name">
          <div class="content">
            <!--手动输入-->
            <mode1 ref="mode1" v-if="activeName === '手动输入'" :order-address="order_address" @onAddress="onAddress"></mode1>
            <!--模板导入-->
            <mode2 v-if="activeName === '模板导入'" @onAddress="onAddress"></mode2>
            <!--自动发货-->
            <mode3
              v-if="activeName === '自动发货'"
              :shop-list="shop_list"
              :mode-name="activeName"
              :source-id="form.source_id * 1"
              :openSendShop="open_send_shop"
              :platform="platform"
              @buildOk="onBuildOk"
              @onSelectOrder="onSelectOrder"
              @onSelectShop="onSelectShop"
            ></mode3>

            <div class="address-table-main" v-if="addType !== 2">
              <div class="address-footer">
                <div class="addr-verification">
                  验证失败<span class="error-qty">{{ error_qty }}</span
                  >条，成功<span class="success-qty">{{ ok_qty }}</span
                  >条
                </div>
                <a class="btn btn1" href="javascript:void(0);" @click="moreAddress(0)">删除选中</a>
                <a class="btn btn2" href="javascript:void(0);" @click="moreAddress(1)">保留选中</a>
                <a class="btn btn2" href="javascript:void(0);">筛选订单</a>
              </div>
              <div class="address-table">
                <el-table ref="multipleTable" :data="addressData" tooltip-effect="dark" max-height="500px" border style="width: 100%" @selection-change="handleSelectionChange">
                  <el-table-column type="selection" width="55" />
                  <el-table-column label="序号" width="70">
                    <template slot-scope="scope">
                      {{ scope.$index + 1 }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="order_no" label="订单编号" width="180" />
                  <el-table-column prop="name" label="姓名" width="120" />
                  <el-table-column prop="mobile" label="电话" width="120" />
                  <el-table-column prop="address" label="地址" />
                  <el-table-column prop="remark" label="快递" />
                  <el-table-column label="操作" width="160">
                    <template slot-scope="scope">
                      <el-button size="mini" type="primary" @click="updateAddress(scope.row, scope.$index)">修改 </el-button>
                      <el-button size="mini" type="danger" @click="deleteAddress(scope.row, scope.$index)">删除 </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>

            <!--            <div v-else class="next-btn-box">-->
            <!--              <div  class="btn-style" @click="onSelectStep(1)">下一步：选择商品</div>-->
            <!--            </div>-->

            <!--选择商品-->
            <div class="product-main">
              <!--              <div class="step-title">选择快递</div>-->
              <!--              <div class="express-list">-->
              <!--                <div class="express-item"-->
              <!--                     v-for="(item, index) in expressData"-->
              <!--                     :class="{'active': express_index === index}"-->
              <!--                     :key="index" @click="onSelectDelivery(index, item.delivery_name)">-->
              <!--                  <span>{{item.delivery_name}}</span>-->
              <!--                </div>-->

              <!--              </div>-->
              <!--              <div class="step-title">选择仓库</div>-->
              <!--              <el-select v-model="gift_param.depot_id" filterable placeholder="请选择选择仓库"-->
              <!--                         style="width: 300px; margin-bottom: 30px;" @change="onSelectDepot">-->
              <!--                <el-option v-for="(item, index) in depot_list" :key="index" :label="item.city+item.delivery_name"-->
              <!--                           :value="item.depot_id"></el-option>-->
              <!--              </el-select>-->

              <div v-if="gift_info" class="select-product-table">
                <div class="select-product-title">确认订单</div>
                <el-table :data="[gift_info]">
                  <el-table-column label="商品图">
                    <template slot-scope="scope">
                      <img height="50px" :src="API_URL + scope.row.image" alt="" />
                    </template>
                  </el-table-column>
                  <el-table-column label="商品名称">
                    <template slot-scope="scope">
                      <span>{{ scope.row.product_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="单价">
                    <template slot-scope="scope">
                      <span style="font-weight:bold;color: #FF0000;">￥{{ scope.row.price }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="数量">
                    <template slot-scope="scope">
                      <span>1</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="重量(kg)" align="center">
                    <template slot-scope="scope">
                      <span>{{ scope.row.weight }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="160">
                    <template slot-scope="scope">
                      <div class="p_btn_box">
                        <a @click="onEditGift" class="p_btn" href="javascript:void(0);">修改</a>
                        <a @click="onDelGift" class="p_btn p_btn2" href="javascript:void(0);">删除</a>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="select-order-info">
                  <div class="select-order-tips">
                    温馨提示：<br />
                    1.请确定好第一步的数据来源平台和快递 出单号后无法撤销退款。<br />
                    2.发货人信息请在对应电商平台添加，以防抽查降权。
                  </div>
                  <div class="select-order-one">
                    <div class="select-order-form">
                      <div class="select-order-form-left">
                        <div class="select-order-form-item">
                          <span class="select-order-form-key">发货地：</span>
                          <span class="select-order-form-val">{{ gift_info.faddress }}</span>
                        </div>
                        <div class="select-order-form-item">
                          <span class="select-order-form-key">仓库：</span>
                          <span class="select-order-form-val">{{ gift_info.delivery_name }} {{ gift_info.depot_name }} </span>
                        </div>
                        <div class="select-order-form-item" v-if="gift_info.collection && gift_info.collection.name">
                          <span class="select-order-form-key">揽收时间：</span>
                          <span class="select-order-form-val">{{ gift_info.collection.name }} </span>
                        </div>
                      </div>
                      <div class="select-order-form-right">
                        <div class="select-order-form">
                          <span class="select-order-form-key">备注：</span>
                          <el-input style="width: 300px;" v-model="desc" placeholder="备注信息仅在平台预览，可不填写"></el-input>
                        </div>
                        <div class="select-order-form">
                          <span class="select-order-form-key">发货人：</span>
                          <el-select style="width: 220px; margin-right: 8px;" v-model="sender_id" filterable clearable placeholder="请选择发货人" @change="onChangeSender">
                            <el-option label="请选择" :value="''"></el-option>
                            <el-option v-for="item in senderList" :key="item.id" :label="item.sender_name + '-' + item.sender_mobile" :value="item.id"> </el-option>
                          </el-select>

                          <a class="sender-btn" href="javascript:void(0);" @click="onSender('add')">新增</a>
                          <span class="btn-icon" style="margin: 0 3px; display: inline-block;">|</span>
                          <a class="sender-btn" href="javascript:void(0);" @click="onSender('edit')">修改</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="select-order-two noSelect">
                    <div class="select-order-two-top">
                      <div class="order-info-item">
                        <span class="order-info-item-key">收件人数：</span>
                        <div class="order-info-item-value">
                          <span class="package-qty">{{ addressData.length || dataonLineOrderShopSelections.length }} </span>
                          <span class="unit">人</span>
                        </div>
                      </div>
                      <div class="order-info-item">
                        <span class="order-info-item-key">礼品总额：</span>
                        <div class="order-info-item-value">
                          <span class="order-price">￥{{ gift_info.price || "0.00" }}</span>
                          <span class="unit">元</span>
                        </div>
                      </div>
                      <div class="order-info-item">
                        <span class="order-info-item-key">礼品运费：</span>
                        <div class="order-info-item-value">
                          <span class="order-price">￥{{ gift_info.depot_price || "0.00" }}</span>
                          <span class="unit">元</span>
                        </div>
                      </div>
                      <div class="order-info-item">
                        <span class="order-info-item-key order-info-item-pay-total">应付总额：</span>
                        <div class="order-info-item-value">
                          <span class="pay-total">￥{{ pay_total }}</span>
                          <span class="unit">元</span>
                        </div>
                      </div>
                    </div>
                    <div class="select-order-footer" v-if="site.cash > 0">
                      <div class="cash-box">每单可抵扣 ¥{{ site.cash_package }}已抵扣 ¥ {{ cashTotal }} (可使用赠金 ¥{{ user_info.cash }}元)</div>
                      <div class="cash-tips">每1赠金 = ¥{{ site.cash_package }}</div>
                    </div>
                    <!-- 超时赔付 -->
                    <div class="overtime">
                      <ul>
                        <el-tooltip class="item" effect="light" placement="top-start">
                          <div slot="content">
                            成功下单后的订单2小时内完成发货并返回快递单号<br />
                            例如：10点付款的订单，所有包裹必须在12点前出单完毕<br />
                            如果超时，平台将自动给您退款补偿<br />
                            揽收超时赔付<br />
                            当天18点前完成付款的包裹，需在第二天12点前产生揽收记录<br />
                            当天18点后完成付款的包裹，需在第二天24点前产生揽收记录<br />
                            如果超时，平台将自动给您赔付补偿每单金额2元
                          </div>
                          <li>
                            <div class="pf-top">
                              <div class="pf-left">
                                <div><img :src="IMG_URL + 'images/pf.png'" /></div>
                                <!-- <div>赔付机制:</div> -->
                              </div>
                              <!-- <div class="pf-right">
                                <div class="pf-content">
                                  
                                </div>
                              </div> -->
                            </div>
                            <div class="pf-bottom">
                              每单加收0.2元，是否开启
                              <el-switch v-model="collectPf"></el-switch>
                            </div>
                          </li>
                        </el-tooltip>

                        <el-tooltip class="item" effect="light" placement="top-start">
                          <div slot="content">
                            揽收后超过72小时未更新中转物流信息的<br />
                            偏远地区例如：新疆、西藏 、青海 、内蒙等偏远地区不在赔付范围<br />
                            特殊情况例如：疫情 天灾 临时出现的禁发区等特殊情况不在赔付范围<br />
                            如果超时，请联系客服核查，经查证平台将自动给您赔付补偿每单金额2元
                          </div>

                          <li>
                            <div class="pf-top">
                              <div class="pf-left">
                                <div><img :src="IMG_URL + 'images/pf_zz.png'" /></div>
                                <!-- <div >赔付机制:</div> -->
                              </div>
                              <!-- <div class="pf-right">
                                <div class="pf-content">
                                  
                                </div>
                              </div> -->
                            </div>
                            <div class="pf-bottom">
                              每单加收0.5元，是否开启
                              <el-switch v-model="transferPf"></el-switch>
                            </div>
                          </li>
                        </el-tooltip>
                      </ul>
                    </div>
                  </div>
                  <div class="select-order-three noSelect">
                    <div class="pay-order-box">
                      <span class="pay-order-key">应付总额：</span>
                      <span class="pay-order-money">￥{{ (pay_total - cashTotal).toFixed(2) }}</span>
                      <span class="unit">元</span>
                    </div>
                    <div class="pay-btn" @click="onAddOrder">提交订单</div>
                  </div>

                  <div class="select-order-four">
                    <span class="address-limit" v-if="gift_info.limit">此仓库禁发地区：{ {{ gift_info.limit }} }</span>
                    <span class="collection" v-if="gift_info.collection && gift_info.collection.down_date">预计出仓库: {{ gift_info.collection.down_date }}</span>
                    <span class="collection" v-if="gift_info.collection && gift_info.collection.name">揽收时间：{{ gift_info.collection.name }}</span>
                  </div>
                </div>
              </div>

              <div v-if="!gift_info" class="step-title">选择商品</div>
              <div v-if="!gift_info" class="add-product-btn" @click="onSelectGift">
                <span class="iconfont icon-jiahao"></span>
                <p class="add-product-btn-text">选择商品</p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--底部-->
    <footer-box></footer-box>

    <!--选择商品-->
    <el-dialog title="商品选择" width="820px" class="dialog-box" :visible.sync="dialogTableVisible" id="select_goods">
      <div class="goods-filter-top noSelect">
        <div class="goods-filter-item">
          <span class="goods-filter-key">分类:</span>
          <div class="goods-filter-copyright">
            <div class="copyright-item" v-for="(item, index) in copyright" :key="index" :class="{ active: index === c_index }" @click="onSelectCategory(item, index)">
              {{ item.category_name }}
            </div>
          </div>
        </div>

        <div class="goods-filter-item goods-express">
          <span class="goods-filter-key pt">快递:</span>
          <div class="goods-filter-express">
            <div class="express-item" v-for="(item, index) in expressData" :class="{ active: express_index === index }" :key="index" @click="onSelectDelivery(index, item.delivery_name)">
              <img
                class="express-icon"
                :class="{ 'express-ems-icon': item.delivery_code === 'POSTB' }"
                :src="`${IMG_URL}images/icons/${express_index === index ? item.delivery_code : item.delivery_code + '2'}.png`"
                alt=""
              />
              <span>{{ item.delivery_name }}</span>
            </div>
          </div>
        </div>
        <div style="margin: 0 0 20px 0;font-size:16px;">【重要】应邮管局要求，韵达自提件不可用于抖音发货！发货后无物流！</div>
        <div class="goods-filter-item">
          <div class="goods-filter-key pt">仓库:</div>
          <div class="goods-depot-list">
            <div class="goods-depot-item" v-for="(item, index) in depot_list" :key="index" :class="{ active: index === depot_index }" @click="onSelectDepot(item, index)">
              {{ item.depot_name | nameFilter }}{{ item.city.substr(0, 2) + item.delivery_name.replace("快递", "").replace("物流", "") }}{{ item.depot_name | typeFilter }}
              <span v-if="item.sort > 9100 && item.sort < 9200" style="color:green;">￥ {{ item.sub[0] }}</span>
              <span v-else style="color:red;">￥ {{ item.sub[0] }}</span>
              <i class="item" v-if="item.sort > 8000 && item.sort < 9000">
                抖音自动发
              </i>
              <i class="item" v-else-if="item.sort > 9000 && item.sort < 9100">
                易通发货
              </i>
              <i class="item" v-else-if="item.sort > 5 && item.sort < 10">
                悦己打单
              </i>
              <i class="item" v-else-if="item.sort > 9100 && item.sort < 9200">
                京东专用
              </i>
              <i class="item" v-else-if="item.sort > 1000 && item.sort < 8000">
                热门推荐
              </i>
              <i class="item" v-else-if="item.sort > 50 && item.sort < 100">
                实物仓
              </i>
              <i class="item" v-else-if="item.sort > 100 && item.sort < 500">
                无货源专用
              </i>
            </div>
          </div>
        </div>
      </div>
      <el-table
        :data="giftData"
        height="350px"
        v-loading="loadingGift"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :default-sort="{ prop: 'date', order: 'descending' }"
      >
        <el-table-column label="商品图" align="center">
          <template slot-scope="scope">
            <img height="50px" :src="API_URL + scope.row.image" alt="" />
          </template>
        </el-table-column>
        <el-table-column label="商品名称" width="220">
          <template slot-scope="scope">
            <span>{{ scope.row.product_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="价格" sortable prop="price">
          <template slot-scope="scope">
            <span style="font-weight:bold;color: #FF0000;">￥{{ scope.row.price }}</span>
          </template>
        </el-table-column>
        <el-table-column label="重量(kg)" sortable align="center" prop="weight">
          <template slot-scope="scope">
            <span>{{ scope.row.weight }}</span>
          </template>
        </el-table-column>
        <el-table-column property="address" label="操作" width="140" :formatter="formatter">
          <template slot-scope="scope">
            <div class="add-goods-cart noSelect" @click="onSelectProduct(scope.row)">加入购物车</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages-box">
        <el-pagination background layout="prev, pager, next" @current-change="onCurrentChange" :total="totalCount"> </el-pagination>
      </div>
      <div class="select-gift noSelect" v-if="gift_info">
        <img class="select-gift-img" :src="API_URL + gift_info.image" alt="" />
        <div class="gift-info">
          <p class="gift-info-item">
            <span class="gift-info-item-key">商品名称：</span>
            <span class="gift-info-item-name">{{ gift_info.product_name }}</span>
          </p>
          <p class="gift-info-item">
            <span class="gift-info-item-key">仓库：</span>
            <span class="gift-info-item-val">{{ gift_info.depot_name }}</span>
          </p>
          <p class="gift-info-item">
            <span class="gift-info-item-key">发货地：</span>
            <span class="gift-info-item-val">{{ gift_info.faddress }}</span>
          </p>
          <p class="gift-info-item">
            <span class="gift-info-item-key">商品价格：</span>
            <span class="gift-info-item-price">￥{{ gift_info.price }}</span>
          </p>
          <p class="gift-info-item">
            <span class="gift-info-item-key">快递运费：</span>
            <span class="gift-info-item-price">￥{{ gift_info.depot_price }}</span>
          </p>
          <p class="gift-info-item">
            <span class="gift-info-item-key">总计：</span>
            <span class="gift-info-item-price">￥{{ giftTotal }}</span>
          </p>
        </div>
      </div>

      <div slot="footer" class="dialog-footer noSelect">
        <div class="add-goods-btn" @click="dialogTableVisible = false">确认添加</div>
      </div>
    </el-dialog>

    <!--修改地址信息-->
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose" title="修改地址" width="550px">
      <div>
        <el-form ref="form" :rules="rules" :model="address_info" label-width="80px">
          <el-form-item label="订单编号" prop="order_no">
            <el-input v-model="address_info.order_no" />
          </el-form-item>
          <el-form-item label="收件人" prop="name">
            <el-input v-model="address_info.name" />
          </el-form-item>
          <el-form-item label="联系电话" prop="mobile">
            <el-input v-model="address_info.mobile" />
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input v-model="address_info.address" />
          </el-form-item>
          <el-form-item label="快递单号" prop="remark">
            <el-input v-model="address_info.remark" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSaveAddress">确 定</el-button>
      </span>
    </el-dialog>

    <!--支付-->
    <div class="pay-meng-main" v-if="dialogVisible2">
      <div class="pay-main">
        <i class="close-icon el-icon-error" @click="onClosePay"></i>
        <div class="pay-content">
          <p class="pay-title">请用<span class="zhifubao">支付宝</span>扫描下方二维码充值</p>
          <img class="zfb-code" :src="payCode" alt="" />
          <p class="pay-money">扫码充值：{{ payMoney }}元</p>
        </div>
        <div class="pay-footer">
          <p class="pay-tips1">无需备注，自动转账</p>
          <p class="pay-tips2">充值成功到账后本页面将出现充值成功提示！</p>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="senderDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleSenderClose"
      :title="sender_param.id ? '修改发货人' : '新增发货人'"
      width="550px"
    >
      <div class="sender-form">
        <el-form :model="sender_param" :rules="sender_rules" ref="senderForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="发货人姓名：" prop="sender_name">
            <el-input style="width: 300px;" v-model="sender_param.sender_name" placeholder="请输入发货人姓名"></el-input>
          </el-form-item>
          <el-form-item label="发货人电话：" prop="sender_mobile">
            <el-input style="width: 300px;" v-model="sender_param.sender_mobile" placeholder="请输入发货人电话"></el-input>
          </el-form-item>
          <el-form-item label="验证码：" prop="sender_mobile">
            <div class="form-item-box">
              <el-input style="width: 180px;" v-model="sender_param.sms_code" placeholder="请输入验证码"></el-input>
              <div class="send-code" @click="onSendSms">{{ btn_text }}</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="sender-dialog-footer noSelect">
        <div class="btn btn-1" @click="handleSenderClose">取消</div>
        <div class="btn btn-2" @click="onSubmitSender">提交</div>
      </div>
    </el-dialog>

    <!--网站通知-->
    <el-dialog :visible.sync="dialogNoticeVisible" :before-close="handleNoticeClose" title="网站通知" class="dialog-box" width="500px">
      <div class="news-detail-content" v-html="noticeContent"></div>
    </el-dialog>
    <loading ref="loading"></loading>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import userNav from "@/components/userNav/index";
import footerBox from "@/components/footerBox/index";
import Mode1 from "./components/mode/mode_1.vue";
import Mode2 from "./components/mode/mode_2.vue";
import Mode3 from "./components/mode/mode_3.vue";

import {
  apiExpressGet,
  apiOrderGetPrice,
  apiProductList,
  apiOrderCreate,
  apiWalletOnLinePut,
  apiWalletCheckPay,
  apiShopLst,
  apiSenderGet,
  apiSenderAdd,
  apiSenderEdit,
  apiSendSms2,
  apiGetPrintApp,
  apiGetNotice,
} from "@/api/api";

import uuid from "uuid";

export default {
  name: "order",
  components: { headerNav, userNav, footerBox, Mode1, Mode2, Mode3 },
  data() {
    return {
      dialogNoticeVisible: false,
      noticeContent: "",
      btn_text: "获取验证码",
      sender_time: 60,
      senderTimeFun: null,
      isSend: false,
      sender_id: "",
      senderList: [],
      sender_rules: {
        sender_name: [{ required: true, message: "请输入发货人姓名", trigger: "blur" }],
        sender_mobile: [{ required: true, message: "请输入发货人电话", trigger: "blur" }],
        sms_code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      sender_param: {
        sender_name: "",
        sender_mobile: "",
        sms_code: "",
      },
      senderDialog: false,
      activeName: "手动输入",
      dialogVisible: false,
      dialogVisible2: false,
      desc: "",
      totalCount: 0,
      addType: 0,
      platform: "TbAcs",
      gift_info: false,
      loadingGift: true,
      dialogTableVisible: false,
      shop_list: [],
      expressData: [],
      express_index: 0,
      depot_list: [],
      depot_index: 0,
      form: {
        qi: 0,
        source_id: 0,
      },
      giftData: [],
      stepCurrent: 0,
      current: 0,
      tabs: [
        { id: 0, name: "手动输入" },
        { id: 1, name: "模板导入" },
        { id: 2, name: "自动发货" },
      ],
      addressData: [],
      select_address: [],
      dataonLineOrderShopSelections: [],
      goods_param: {
        limit: 10,
        page: 1,
        sort: "",
        keyword: "",
      },
      gift_param: {
        page: 1,
        total: 0,
        depot_id: "",
        category_id: "",
        keyword: "",
        limit: 20,
        sort: "",
      },
      order_param: {
        shop_id: "",
        tids: "",
        shop_type: "",
        platform: "",
        limit: 10,
        page: 1,
        status: 0,
        remark_tag: "",
      },
      sort_list: [
        { name: "默认排序", sort: "" },
        { name: "价格最低", sort: "price_asc" },
        {
          name: "销量最高",
          sort: "sales_desc",
        },
        { name: "重量最重", sort: "weight_desc" },
        { name: "最新发布", sort: "time_desc" },
      ],
      list: [
        {
          name: "淘宝/天猫",
          source_id: 0,
          platform: "TbAcs",
          icon: "icon-taobao",
          set_addr_url: "https://wuliu.taobao.com/user/logis_tools.htm",
        },
        {
          name: "京东",
          source_id: 1,
          platform: "JdAcs",
          icon: "icon-jingdong",
          set_addr_url: "https://delivery.shop.jd.com/returnAddress/list",
        },
        {
          name: "拼多多",
          source_id: 2,
          platform: "PddAcs",
          icon: "icon-pinduoduo",
          set_addr_url: "https://mms.pinduoduo.com/orders/order/carriage/addressManagement",
        },
        {
          name: "抖音",
          source_id: 4,
          platform: "DyAcs",
          icon: "icon-douyin",
          set_addr_url: "https://fxg.jinritemai.com/ffa/morder/logistics/address-list",
        },
        { name: "快手", source_id: 5, platform: "KsAcs", icon: "icon-kuaishou", set_addr_url: "" },
        // { name: '其他', source_id: 3, platform: '', icon: 'other.png', set_addr_url: '' }
      ],
      rules: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        address: [{ required: true, message: "地址不能为空", trigger: "blur" }],
        mobile: [{ required: true, message: "联系电话不能为空", trigger: "blur" }],
        remark: [{ required: false, message: "", trigger: "blur" }],
      },
      error_qty: 0,
      ok_qty: 0,
      address_info: {},
      update_index: "",
      isClick: true,
      isClickRef: true,
      putLoading: false,
      loading_text: "拼命加载中",
      express_name: "",
      payCode: "",
      payMoney: 0,
      c_index: 0,
      order_address: "",
      open_send_shop: {},
      // 赔付
      collectPf: false,
      transferPf: false,
      // token
      orderToken: uuid().replace(new RegExp("-", "g"), "", -1),
    };
  },
  filters: {
    typeFilter(val) {
      var type = "";
      if (val.indexOf("自提") !== -1) {
        type = "-自提";
      } else if (val.indexOf("部分自提") !== -1) {
        type = "-部分自提";
      }
      return type;
    },
    nameFilter(val) {
      var name = "";
      // if (val.indexOf('推荐') !== -1) {
      //   name = '[推荐]'
      // }
      return name;
    },
  },
  computed: {
    pay_total() {
      let qty = this.select_address.length;
      if (this.addType == 2) {
        qty = this.dataonLineOrderShopSelections.length;
      }
      if (qty == 0) {
        return "0.00";
      } else {
        if (typeof this.gift_info.depot_price !== "undefined" && typeof this.gift_info.price !== "undefined") {
          let total = qty * (Number(this.gift_info.depot_price) + Number(this.gift_info.price));
          return total.toFixed(2);
        }
        return "0.00";
      }
    },
    giftTotal() {
      let total = 0;
      if (this.gift_info) {
        total = parseFloat(this.gift_info.depot_price) + parseFloat(this.gift_info.price);
      }
      return total.toFixed(2);
    },
    cashTotal() {
      let total = 0;
      if (this.site.cash > 0 && this.user_info.cash > 0) {
        total = this.select_address.length * this.site.cash_package;
      }
      return total.toFixed(2);
    },
    copyright() {
      var copyright = [{ category_name: "全部分类", id: "" }];
      copyright = copyright.concat(this.$store.getters.copyright_lst);
      return copyright;
    },
    site() {
      return this.$store.getters.site;
    },
    user_info() {
      return this.$store.getters.user_info;
    },
    manystore() {
      return this.$store.getters.manystore || { order_ups_text: "" };
    },
  },
  mounted() {
    if (this.manystore.order_ups_text && this.manystore.order_ups_text.length > 20) {
      this.noticeContent = this.manystore.order_ups_text;
      this.dialogNoticeVisible = true;
    }

    apiGetPrintApp().then(res => {
      this.open_send_shop = res.data;
    });

    this.getShopList();
    this.expressGet();
    // this.getOrderPrice()
    this.getSenderGet();
    const convenient_order_add = localStorage.getItem("convenient_order_add");
    if (convenient_order_add) {
      this.putLoading = true;
      this.loading_text = "信息解析中。。。";
      this.convenientOrderAdd();
    }
    // console.log("orderToken",this.orderToken);
  },
  methods: {
    onChangeSender() {
      this.sender_param = {
        sender_name: "",
        sender_mobile: "",
        sms_code: "",
      };
      for (let i = 0; i < this.senderList.length; i++) {
        if (this.sender_id === this.senderList[i].id) {
          this.sender_param.sender_name = this.senderList[i].sender_name;
          this.sender_param.sender_mobile = this.senderList[i].sender_mobile;
        }
      }
    },
    handleNoticeClose() {
      this.dialogNoticeVisible = false;
    },
    handleSenderClose() {
      this.senderDialog = false;
      this.btn_text = "获取验证码";
      this.sender_time = 60;
      clearInterval(this.senderTimeFun);
      this.$refs["senderForm"].resetFields();
      this.isSend = false;
    },
    //新增/修改发货人
    onSender(type) {
      if ((this.sender_id || this.sender_id > 0) && type === "edit") {
        this.sender_param.id = this.sender_id;
        for (let i = 0; i < this.senderList.length; i++) {
          if (this.sender_id === this.senderList[i].id) {
            this.sender_param.sender_name = this.senderList[i].sender_name;
            this.sender_param.sender_mobile = this.senderList[i].sender_mobile;
          }
        }
      } else {
        this.sender_param = {
          sender_name: "",
          sender_mobile: "",
          sms_code: "",
        };
      }
      this.senderDialog = true;
    },
    //发货验证码
    onSendSms() {
      if (!this.sender_param.sender_mobile) {
        this.$message.info("请输入手机号码");
        return false;
      }
      if (this.isSend) return;
      this.isSend = true;
      apiSendSms2({
        mobile: this.sender_param.sender_mobile,
        event: "sender_check",
      }).then(res => {
        if (res.code === 1) {
          this.$message.success("验证码已发送至：" + this.sender_param.sender_mobile);
          this.senderTimeFun = setInterval(() => {
            if (this.sender_time > 0) {
              this.sender_time--;
              this.btn_text = this.sender_time + "s";
            } else {
              this.btn_text = "获取验证码";
              this.isSend = false;
              this.sender_time = 60;
              clearInterval(this.senderTimeFun);
            }
          }, 1000);
        }
      });
    },

    //提交发货人信息
    onSubmitSender() {
      this.$refs["senderForm"].validate(valid => {
        if (valid) {
          if (this.sender_id || this.sender_id > 0) {
            apiSenderEdit(this.sender_param).then(res => {
              if (res.code === 1) {
                this.$message.success("添加成功");
                this.handleSenderClose();
                this.getSenderGet();
              }
            });
          } else {
            apiSenderAdd(this.sender_param).then(res => {
              if (res.code === 1) {
                this.$message.success("添加成功");
                this.handleSenderClose();
                this.getSenderGet();
              }
            });
          }
        }
      });
    },

    //获取发货人列表
    getSenderGet() {
      apiSenderGet({ limit: 99 }).then(res => {
        if (res.code === 1) {
          this.senderList = res.data;
        }
      });
    },
    //商品价格排序回调
    formatter(row, column) {
      return row.address;
    },
    onSelectShop(param) {
      this.order_param = Object.assign(this.order_param, param);
    },
    onSelectOrder(data) {
      this.dataonLineOrderShopSelections = data;
    },
    //绑定店铺成功
    onBuildOk(source) {
      if (this.form.source_id != source) {
        this.form.source_id = source;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].source_id == source) {
            this.platform = this.list[i].platform;
          }
        }
        this.onSource({ source_id: source || 0, platform: this.platform }, "自动发货");
      } else {
        this.getShopList();
      }
    },
    // 我已支付|稍后操作
    onClosePay() {
      this.dialogVisible2 = false;
    },
    convenientOrderAdd() {
      var convenient_order_add = localStorage.getItem("convenient_order_add");
      if (typeof convenient_order_add !== "undefined") {
        convenient_order_add = JSON.parse(convenient_order_add);
        if (typeof convenient_order_add.source !== "undefined") {
          this.form.source_id = convenient_order_add.source * 1;
          this.getOrderPrice();
          this.addType = 0;
          var html = "";
          for (var i = 0; i < convenient_order_add.package.length; i++) {
            html += convenient_order_add.package[i] + " \r\n";
          }
          this.order_address = html;
        }
      }
      setTimeout(function() {
        localStorage.removeItem("convenient_order_add");
      }, 3000);
    },

    // 多选地址操作 type 0删除选中 1保留选中 2筛选地址
    moreAddress(type) {
      var data = this.addressData;
      switch (type) {
        case 0:
          data.forEach((item, index) => {
            var d = item.name + "" + item.mobile + "" + item.order_no;
            this.select_address.forEach(item2 => {
              var d2 = item2.name + "" + item2.mobile + "" + item2.order_no;
              if (d === d2) {
                this.addressData.splice(index, 1);
              }
            });
          });
          this.select_address = [];
          break;
        case 1:
          this.addressData = this.select_address;
          break;
        case 2:
          break;
      }
    },
    // 取消修改地址
    handleClose() {
      this.address_info = {};
      this.dialogVisible = false;
    },
    // 保存修改地址
    onSaveAddress() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          Object.assign(this.addressData[this.update_index], this.address_info);
          this.handleClose();
        }
      });
    },
    // 修改地址
    updateAddress(row, index) {
      this.update_index = index;
      this.address_info = Object.assign({}, row);
      this.dialogVisible = true;
    },
    // 删除地址
    deleteAddress(row, index) {
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.addressData.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 地址多选
    handleSelectionChange(value) {
      this.select_address = value;
    },
    // 生成地址后全部默认选择
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable[0].toggleRowSelection(row);
        });
        this.select_address = rows;
      } else {
        this.$refs.multipleTable[0].clearSelection();
      }
    },
    onAddress(row) {
      this.addressData = row.data;
      this.error_qty = row.error_qty;
      this.ok_qty = this.addressData.length;
      this.select_address = row.data;
      setTimeout(() => {
        this.toggleSelection(row.data);
      }, 1000);
    },
    //修改已选商品
    onEditGift() {
      this.dialogTableVisible = true;
    },
    //删除已选商品
    onDelGift() {
      this.gift_info = false;
      this.gift_param.product_id = "";
    },
    //选择下单方式
    handleClick(tab, event) {
      const index = Number(tab.index);
      this.addType = index;
      this.activeName = index === 0 ? "手动输入" : index === 1 ? "模板导入" : index === 2 ? "自动发货" : "";
      // console.log(this.activeName,this.platform);
      if (this.platform == "TbAcs" && this.activeName == "自动发货") {
        // 获取公告
        apiGetNotice().then(res => {
          if (res.length > 2) {
            // 弹窗
            this.$alert(res, "公告", {
              confirmButtonText: "确定",
              callback: action => {
                // this.$message({
                //   type: 'info',
                //   message: `action: ${ action }`
                // });
              },
            });
          }
        });
      }
      this.getOrderPrice();
    },
    // 选择数据来源
    onSource(row, name) {
      this.express_name = "";
      this.express_index = 0;
      this.giftData = [];
      this.form.source_id = row.source_id;
      this.addType = name ? 2 : 0;
      this.activeName = name || "手动输入";
      this.gift_param = {
        product_id: "",
        page: 1,
        total: 0,
        depot_id: "",
        category_id: "",
        limit: 20,
        sort: "",
      };
      this.order_param = {
        shop_id: "",
        shop_type: "",
        platform: row.platform,
        limit: 10,
        page: 1,
        status: 0,
        remark_tag: "",
      };
      this.platform = row.platform;
      this.gift_info = false;
      if (this.addType == 2) {
        this.order_param.shop_id = "";
        // this.order_list = []
      }
      this.expressGet();
      this.getShopList();
      this.getOrderPrice();
    },
    //获取快递列表
    expressGet() {
      apiExpressGet().then(res => {
        var express_list = [{ delivery_name: "全部", delivery_code: "" }];
        this.expressData = express_list.concat(res.data.rows);
      });
    },
    //选择类型
    onSelectCategory(row, index) {
      this.c_index = index;
      this.gift_param.category_id = row.id;
      this.getGiftProduct();
    },
    // 选择快递
    onSelectDelivery(index, name) {
      this.express_index = index;
      this.express_name = name != "全部" ? name : "";
      this.depot_index = 0;
      this.giftData = [];
      this.gift_param.depot_id = "";
      this.gift_info = false;
      this.getOrderPrice();
    },
    // 获取店铺列表
    getShopList() {
      this.shop_list = [];
      apiShopLst({ platform: this.platform }).then(res => {
        if (res.code === 1) {
          this.shop_list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取快递
    getOrderPrice() {
      this.depot_list = [];
      var giftData = localStorage.getItem("giftData");
      if (giftData) {
        giftData = JSON.parse(giftData);
        this.form.source_id = Number(giftData.source);
      }
      apiOrderGetPrice({
        source: this.form.source_id,
        express_name: this.express_name,
        mode: this.addType,
      }).then(res => {
        this.depot_list = res.data;
        // console.log(res.data);
        if (giftData) {
          var gift = giftData.gift;
          console.log(gift.stocks[0]);
          for (let i = 0; i < this.depot_list.length; i++) {
            var item = this.depot_list[i];
            for (let k = 0; k < gift.stocks.length; k++) {
              if (gift.stocks[k].depot_id == item.depot_id) {
                gift["depot_id"] = item.depot_id;
                gift["depot_name"] = item.depot_name;
                gift["faddress"] = item.faddress;
                gift["collection"] = item.collection;
                gift["limit"] = item.limit;
                gift["delivery_name"] = item.delivery_name;
                gift["depot_price"] = gift.stocks[k].depot_price;
                gift["price"] = gift.stocks[k].sales_price;
                this.gift_param.depot_id = item.depot_id;
                this.depot_index = i;
                break;
              }
            }
          }
          this.gift_info = gift;
          this.gift_param.product_id = giftData.product_id;
          this.dialogTableVisible = true;
          localStorage.removeItem("giftData");
        }
        if (!this.gift_param.depot_id && this.depot_list.length > 0) {
          this.gift_param.depot_id = this.depot_list[0].depot_id;
        } else {
          // this.gift_param.depot_id = 0;
        }
        this.getGiftProduct();
      });
    },
    // 选择仓库
    onSelectDepot(row, index) {
      this.gift_info = false;
      this.depot_index = index;
      this.gift_param.depot_id = row.depot_id;
      // for (let i = 0; i < this.depot_list.length; i++) {
      //   if (this.depot_list[i].depot_id == this.gift_param.depot_id) {
      //     this.depot_index = i;
      //   }
      // }
      this.getGiftProduct();
    },
    // 选择礼品
    onSelectProduct(row) {
      console.log(row);
      console.log(this.c_index);
      row["depot_id"] = this.gift_param.depot_id;
      row["depot_name"] = this.depot_list[this.depot_index].depot_name;
      row["faddress"] = this.depot_list[this.depot_index].faddress;
      row["delivery_name"] = this.depot_list[this.depot_index].delivery_name;
      row["collection"] = this.depot_list[this.depot_index].collection;
      row["limit"] = this.depot_list[this.depot_index].limit;
      this.gift_info = row;
      this.$message.success("加入购物车成功");
      this.scrollToBottom();
    },
    scrollToBottom: function() {
      this.$nextTick(() => {
        var container = this.$el.querySelector(".dialog-box .el-dialog__body");
        container.scrollTop = container.scrollHeight;
      });
    },
    onSelectGift() {
      this.dialogTableVisible = true;
      this.getOrderPrice();
    },
    onSelectStep(index) {
      this.stepCurrent = index;
    },
    onCurrentChange(val) {
      this.gift_param.page = val;
      this.getGiftProduct();
    },
    // 礼品筛选
    onSearchGift() {
      this.gift_param.page = 1;
      this.getGiftProduct();
    },
    // 获取礼品
    getGiftProduct() {
      if (this.gift_param.depot_id == "") {
        this.loadingGift = false;
        return;
      }
      this.loadingGift = true;
      apiProductList(this.gift_param).then(res => {
        this.loadingGift = false;
        this.loadingGift = false;
        this.totalCount = res.data.total;
        this.giftData = res.data.rows;
        if (this.gift_param.product_id) {
          this.giftData.forEach((item, index) => {
            if (item.id == this.gift_param.product_id) {
              // this.onSelectProduct(item)
            }
          });
        }
      });
    },
    // 提交订单
    onAddOrder() {
      if (this.gift_param.depot_id == "") {
        this.$message.info("请选择快递");
        return;
      }
      if (typeof this.gift_info.id === "undefined") {
        this.$message.info("请选择商品");
        return;
      }
      // 判断五货源
      let ls_w = this.gift_info.product_name + this.gift_info.depot_name;
      if (ls_w.indexOf("无货源") > -1) {
        for (let ls_i = 0; ls_i < this.select_address.length; ls_i++) {
          if (this.select_address[ls_i].remark == undefined || this.select_address[ls_i].remark.length < 5) {
            this.$message.info("无货源仓库请检查快递单号是否正确");
            return;
          }
        }
      }
      // return;
      let param = {};
      let pf_type1 = -1;
      if (this.collectPf) {
        pf_type1 = 0;
        if (this.transferPf) {
          pf_type1 = 2;
        }
      } else {
        if (this.transferPf) {
          pf_type1 = 1;
        }
      }
      // console.log(pf_type);
      // return;
      if (this.addType == 2) {
        if (this.dataonLineOrderShopSelections.length == 0) {
          this.$message.info("请选择可发货的订单");
          return;
        }
        const _package = [];
        this.dataonLineOrderShopSelections.forEach((item, index) => {
          _package.push(item.tid);
        });
        param = {
          mode: this.addType,
          source: this.form.source_id,
          product_id: this.gift_info.id,
          depot_id: this.gift_param.depot_id,
          product_num: 1,
          package: window.encodeURIComponent(JSON.stringify(_package)),
          is_delivery: 1,
          remark: this.desc,
          shop_id: this.order_param.shop_id,
          shop_type: this.order_param.shop_type,
          pf_type: pf_type1,
          order_token: this.orderToken,
        };
        const that = this;
        this.$confirm("自动发货需要设置售后/退货地址，否则自动发货失败，如未设置请前往设置再发货。", "告示", {
          confirmButtonText: "已设置继续下单",
          cancelButtonText: "前往设置",
          type: "warning",
        })
          .then(() => {
            that.orderCreate(param);
          })
          .catch(() => {
            var url = "";
            for (let i = 0; i < that.list.length; i++) {
              if (that.form.source_id === that.list[i].source_id) {
                window.open(that.list[i].set_addr_url);
                break;
              }
            }
          });
      } else {
        if (this.select_address.length == 0) {
          this.$message.info("缺少收货人信息");
          return;
        }
        param = {
          mode: this.addType,
          source: this.form.source_id,
          product_id: this.gift_info.id,
          depot_id: this.gift_param.depot_id,
          product_num: 1,
          package: encodeURIComponent(JSON.stringify(this.select_address)),
          is_delivery: 0,
          remark: this.desc,
          is_score: 0,
          pf_type: pf_type1,
          order_token: this.orderToken,
        };
        this.orderCreate(param);
      }
    },
    orderCreate(param) {
      if (!this.isClick) {
        return false;
      }
      // this.isClickRef = false
      if (!this.isClickRef) {
        // 跳转到订单界面
        this.$message.info("重复点击,请检查是否下单成功");
        setTimeout(() => {
          this.$router.push("/order/lst");
        }, 1000);
        return false;
      }
      this.isClickRef = false;
      this.isClick = false;
      this.$refs.loading.open();
      if (this.sender_param.sender_mobile && this.sender_param.sender_name) {
        param.sender_mobile = this.sender_param.sender_mobile;
        param.sender_name = this.sender_param.sender_name;
      }
      apiOrderCreate(param)
        .then(res => {
          setTimeout(() => {
            this.isClick = true;
          }, 1000);
          if (res.code === 1) {
            this.$refs.loading.close();
            this.$store.dispatch("GetUserInfo");
            this.$store.dispatch("getIndexConfig");
            this.$message.success(res.msg);
            setTimeout(() => {
              this.$router.push("/order/lst");
            }, 2000);
          } else {
            this.isClick = true;
            this.$refs.loading.close();
            if (typeof res.data.type !== "undefined") {
              if (res.data.type == "online") {
                this.differencePay(res.data.difference);
              }
            }
          }
        })
        .catch(err => {
          this.$refs.loading.close();
          this.isClick = true;
          this.$message.info("操作失败,请检查是否下单成功");
          setTimeout(() => {
            this.$router.push("/order/lst");
          }, 1000);
        });
    },
    differencePay(money) {
      var that = this;
      apiWalletOnLinePut({ money: money, type: "qr" }).then(res => {
        if (res.data.url) {
          if (typeof res.data.paytotal != "undefined") {
            this.payMoney = res.data.paytotal;
          }

          this.$confirm(
            '为避免延迟到账或不到账，请务必准确支付<strong class="payMoney">' + this.payMoney + "</strong>元,最终到账金额<strong class='payMoney'>" + this.payMoney + "</strong>元！",
            "提示",
            {
              confirmButtonText: "确定",
              type: "warning",
              dangerouslyUseHTMLString: true,
            }
          )
            .then(() => {
              this.payCode = this.API_URL + "api/wallet/getQrcode.html?text=" + res.data.url + "&orderid=" + res.data.orderid + "&paytotal=" + res.data.paytotal;
              this.dialogVisible2 = true;
              this.check_is_pay(res.data.orderid);
            })
            .catch(() => {});
        } else {
          this.$confirm("当前余额不足, 去充值?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            that.$router.push("/recharge");
          });
        }
      });
    },
    check_is_pay(orderid) {
      apiWalletCheckPay({ orderid: orderid }).then(res => {
        if (res.code == 1) {
          this.$message.success("支付成功");
          this.dialogVisible2 = false;
          // this.onAddOrder()
        } else {
          setTimeout(() => {
            this.check_is_pay(orderid);
          }, 2000);
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
.payMoney {
  color: red;
  font-size: 20px;
}
.order {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  // background-color: #eeeeee;

  .source-list {
    position: absolute;
    // top: 10px;

    margin-top: -70px;

    .express-button {
      // 悬浮按钮
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #fff;
      z-index: 999;
      padding: 10px 0;
      border-top: 1px solid #e5e5e5;
    }

    .source-item {
      float: left;
      margin-left: 10px;

      width: 160px;
      height: 60px;
      margin-bottom: 10px;
      background-color: #ffffff;
      display: flex;
      align-items: center;
      padding: 0 30px;
      cursor: pointer;

      .iconfont {
        margin-right: 10px;
        color: #000000;
        font-size: 22px;
      }

      .source-text {
        font-size: 14px;
        color: #000000;
        font-weight: 400;
      }

      &.active {
        background-color: #ff0000;

        .iconfont {
          color: #ffffff;
        }

        .source-text {
          color: #ffffff;
        }
      }
    }
  }

  .user-center {
    width: 1300px;
    margin: 0px auto 0;
    padding-left: 180px;

    .border-card-main {
      margin-top: 80px;
      min-height: calc(100vh - 310px);
      background-color: #ffffff;
    }

    .content {
      padding: 20px;

      .button-box {
        .btn1 {
          color: #0f375a;
          font-size: 12px;
        }

        .btn2 {
          color: #999999;
          font-size: 12px;
        }
      }
    }

    .step-main {
      height: 40px;
      background-color: #767676;
      z-index: 1000;
      display: flex;
      align-items: center;

      .step-item {
        width: calc(100% / 2);
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        height: 40px;
        cursor: pointer;

        &:hover {
          background-color: #0f375a;
          color: #000;
        }

        &.active {
          background-color: #0f375a;
          color: #000;
        }
      }
    }

    .address-table {
      margin-bottom: 30px;
    }

    .address-footer {
      margin: 20px 0;
      display: flex;
      align-items: center;

      .addr-verification {
        color: #0f375a;
        width: 480px;
        height: 30px;
        font-size: 14px;
        background-color: #f3f3f3;
        display: flex;
        align-items: center;
        padding: 0 25px;
        margin-right: 20px;

        .error-qty {
          color: #ff0000;
        }

        .success-qty {
          color: #28e000;
        }
      }

      .btn {
        height: 30px;
        line-height: 30px;
        padding: 0 12px;
        margin-right: 20px;
        font-size: 14px;
      }

      .btn1 {
        background-color: #0f375a;
        color: #ffffff;
      }

      .btn2 {
        color: #0f375a;
        border: 1px solid #0f375a;
      }
    }

    .next-btn-box {
      text-align: center;
    }

    .product-main {
      .step-title {
        font-weight: bold;
        font-size: 16px;
        color: #0f375a;
        margin-bottom: 15px;
      }

      .express-list {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 30px;

        .express-item {
          cursor: pointer;
          width: 150px;
          height: 55px;
          border: 1px solid #e6e6e6;
          margin-right: 10px;
          margin-bottom: 10px;
          color: #616161;
          display: flex;
          align-items: center;
          justify-content: center;

          &:hover {
            background-color: #0f375a;
            color: #ffffff;
            border-color: #0f375a;
          }

          &.active {
            background-color: #0f375a;
            color: #ffffff;
            border-color: #0f375a;
          }
        }
      }

      .add-product-btn {
        width: 180px;
        height: 180px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background-color: #eaeaea;

        .iconfont {
          font-size: 58px;
          color: #878787;
        }

        .add-product-btn-text {
          color: #878787;
          font-size: 14px;
        }
      }
    }
  }

  .goods-filter-top {
    margin-bottom: 10px;

    .goods-express {
      margin-bottom: 10px;
    }

    .goods-filter-item {
      display: flex;
      flex: none;

      .goods-filter-key {
        font-size: 14px;
        color: #999;
        margin-right: 10px;

        &.pt {
          padding-top: 6px;
        }
      }

      .goods-filter-express {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        .express-item {
          width: 120px;
          height: 30px;
          font-size: 12px;
          margin-right: 10px;
          margin-bottom: 10px;
          border: 1px solid #e6e6e6;
          color: #616161;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .express-icon {
            height: 14px;
            width: auto;
            margin-right: 3px;
          }

          .express-ems-icon {
            height: auto;
            width: 25px;
          }

          &.active {
            color: #ffffff;
            background-color: #0f375a;
            border-color: #0f375a;
          }
        }
      }

      .goods-filter-copyright {
        display: flex;
        align-items: center;

        margin-bottom: 15px;

        .copyright-item {
          margin-right: 30px;
          cursor: pointer;
          font-size: 14px;

          &.active {
            font-weight: bold;
            color: #0f375a;
          }
        }
      }

      .goods-depot-list {
        flex: 1;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        min-height: 36px;

        .goods-depot-item {
          width: 130px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #e6e6e6;
          margin-bottom: 5px;
          font-size: 12px;
          margin-right: 10px;
          cursor: pointer;
          position: relative;

          &:hover {
            color: #ffffff;
            background-color: #0f375a;
            border-color: #0f375a;
          }

          &.active {
            color: #ffffff;
            background-color: #0f375a;
            border-color: #0f375a;
          }

          .item {
            background: #f05555;
            border-color: #f05555;
            display: block;
            padding: 0 6px;
            font-size: 12px;
            white-space: nowrap;
            height: 18px;
            color: #fff;
            line-height: 18px;
            border-radius: 4px;
            position: absolute;
            top: -15px;
            left: 80%;
            font-style: normal;
            animation: tag1 2s linear infinite;
            -webkit-animation: tag1 2s linear infinite;
          }

          @keyframes tag1 {
            0% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-5px);
            }
            100% {
              transform: translateY(0);
            }
          }

          .item::after {
            content: "";
            display: block;
            border: 4px solid transparent;
            border-style: solid;
            border-top-color: inherit;
            position: absolute;
            top: 100%;
            left: 4px;
          }
        }
      }
    }

    //.search-btn {
    //  width: 80px;
    //  height: 30px;
    //  background-color: #0f375a;
    //  text-align: center;
    //  line-height: 30px;
    //  color: #ffffff;
    //  margin-left: 10px;
    //  cursor: pointer;
    //}
  }

  .pages-box {
    margin: 10px 0;
  }

  .select-gift {
    padding: 10px;
    background-color: #eeeeee;
    display: flex;
    align-items: center;

    .select-gift-img {
      width: 100px;
      height: 100px;
      margin-right: 10px;
    }

    .gift-info {
      p {
        margin: 0;
      }

      .gift-info-item {
        .gift-info-item-key {
          display: inline-block;
          width: 80px;
        }

        .gift-info-item-val {
          color: #000000;
        }

        .gift-info-item-name {
          font-weight: bold;
          color: #000000;
        }

        .gift-info-item-price {
          font-weight: bold;
          color: #ff0000;
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .add-goods-btn {
      width: 100px;
      height: 35px;
      background-color: #0f375a;
      text-align: center;
      line-height: 35px;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }
  }

  .add-goods-cart {
    font-size: 12px;
    width: 80px;
    height: 25px;
    background-color: #0f375a;
    text-align: center;
    line-height: 25px;
    color: #ffffff;
    cursor: pointer;
  }

  .select-product-table {
    .select-product-title {
      font-weight: bold;
      font-size: 16px;
      color: #0f375a;
      margin: 20px 0;
    }

    .p_btn_box {
      .p_btn {
        font-size: 12px;
        font-weight: bold;
        color: #0f375a;
        margin-right: 10px;
      }

      .p_btn2 {
        color: #ff0000;
      }
    }

    .select-order-info {
      margin-top: 20px;

      .select-order-tips {
        color: #ff0000;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 14px;
      }

      .select-order-one {
        padding: 25px;
        background-color: #f5f6f7;
        margin-bottom: 8px;

        .select-order-form {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .select-order-form-left {
            .select-order-form-item {
              line-height: 30px;

              .select-order-form-key {
                display: inline-block;
                width: 70px;
                text-align: right;
                color: #999;
              }

              .select-order-form-val {
                font-weight: bold;
                color: #000;
              }
            }
          }

          .select-order-form-right {
            .select-order-form {
              margin-bottom: 5px;

              .select-order-form-key {
                width: 60px;
                text-align: right;
              }

              .sender-btn {
                display: inline-block;
                color: #0f375a;
                font-weight: bold;
              }
            }
          }
        }
      }

      .select-order-two {
        padding: 25px;
        background-color: #f5f6f7;
        margin-bottom: 8px;
        position: relative;

        .select-order-two-top {
          margin-bottom: 20px;

          .order-info-item {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-bottom: 10px;

            .order-info-item-key {
              display: inline-block;
              font-weight: 400;
              color: #616161;
            }

            .order-info-item-pay-total {
              color: #000000;
            }

            .order-info-item-value {
              width: 100px;
              text-align: right;
              font-size: 14px;

              .package-qty {
                color: #000000;
                font-size: 16px;
              }

              .order-price {
                color: #0f375a;
                font-size: 18px;
                font-weight: bold;
              }

              .pay-total {
                font-weight: bolder;
                color: #ff0000;
                font-size: 22px;
              }

              .unit {
                font-size: 14px;
                color: #616161;
              }
            }
          }
        }

        div.overtime {
          width: 70%;
          height: 165px;
          float: left;
          line-height: 28px;
          justify-content: flex-start;
          position: absolute;
          top: 10px;
          font-size: 16px;
          margin-top: 30px;
          // background-color: red;

          ul {
            list-style: none;
            margin: 0;
            padding: 0;
            // background-color: red;
            height: 100%;
            li {
              border: #e6e6e6 1px solid;
              float: left;
              width: 48%;
              height: 50%;
              text-align: center;
              margin-right: 5px;
              cursor: pointer;
              .pf-top {
                float: left;
                // background-color: brown;
                width: 100%;
                height: 70%;
                // background-color: blue($color: #000000);
              }
              .pf-left {
                width: 100%;
                float: left;
                text-align: center;
                margin: 10px auto;
                img {
                  width: 82px;
                }
              }
              // .pf-right{
              //   padding: 10px;
              //   width: 69%;
              //   height: 50%;
              //   float: left;
              //   font-weight: bold;
              //   // background-color: blue;
              // }
              .pf-bottom {
                position: absolute;
                bottom: 65px;
                padding-bottom: 30px;
                margin-left: 30px;
              }
            }
          }
        }

        .select-order-footer {
          border-top: 1px solid #dfdfdf;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-top: 20px;
          color: #616161;

          .cash-tips {
            margin-left: 20px;
            color: #0f375a;
          }
        }
      }

      .select-order-three {
        margin-top: 30px;
        border: 1px solid #e6e6e6;
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .pay-order-box {
          .pay-order-key {
            color: #000000;
            font-size: 16px;
          }

          .pay-order-money {
            color: #ff0000;
            font-size: 22px;
            font-weight: bold;
          }

          .unit {
            font-size: 14px;
            color: #ff0000;
          }
        }

        .pay-btn {
          height: 55px;
          width: 140px;
          background-color: #0f375a;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-size: 16px;
          margin-left: 20px;
          cursor: pointer;
        }
      }

      .select-order-four {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 10px;

        span {
          display: inline-block;
          margin-left: 20px;
        }
      }
    }
  }

  .sender-form {
    .form-item-box {
      width: 300px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .send-code {
        width: 100px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        background-color: #0f375a;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }

  .sender-dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .btn {
      width: 80px;
      height: 40px;
      margin-left: 15px;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }

    .btn-1 {
      border: 1px solid #dddddd;
      color: #999;
    }

    .btn-2 {
      background-color: #0f375a;
      color: #ffffff;
    }
  }

  .pay-meng-main {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1000;

    .pay-main {
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      width: 320px;
      height: 370px;
      background-color: #0f375a;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 20px;

      .close-icon {
        font-size: 30px;
        color: #ffffff;
        position: absolute;
        right: -10px;
        top: -10px;
        cursor: pointer;
      }

      .pay-content {
        width: 280px;
        height: 280px;
        background-color: #ffffff;
        border-radius: 10px 10px 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        .zfb-code {
          width: 180px;
          height: 180px;
        }

        .pay-title {
          font-size: 14px;
          color: #000000;

          .zhifubao {
            color: #0f375a;
          }
        }

        .pay-money {
          font-size: 20px;
          font-weight: bold;
          color: #ff0000;
        }
      }

      .pay-footer {
        p {
          margin: 0;
          font-size: 12px;
          text-align: center;
          color: #ffffff;
          margin-top: 5px;
        }

        .pay-tips2 {
          font-weight: bolder;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/add.vue